import { Model } from 'vue-mc'
import { Request } from '@/http'
import { pluralize } from 'inflected'
import isEmpty from 'lodash'
import each from 'lodash'
import Vue from 'vue'

class BaseModel extends Model {
    registerAttribute(attribute) {
        if (attribute === 'attributes') {
            return
        }

        return super.registerAttribute(attribute)
    }

    getPrimaryKey() {
        return this.attributes.id
    }

    setIncludes(include) {
        this.setOption('query.include', include)
        return this
    }

    getFetchQuery() {
        return this.getOption('query')
    }

    getRequest(config) {
        return new Request(config)
    }

    request(config, onRequest, onSuccess, onFailure) {
        //// console.log('request....', config)
        return super.request(config, onRequest, onSuccess, onFailure)
    }

    setErrors(errors) {
        // console.log('Inside errors', errors)
        if (isEmpty(errors)) {
            Vue.set(this, '_errors', {})
            return
        }

        each(errors, (errors, attribute) => {
            this.setAttributeErrors(attribute, errors)
        })
    }

    routes() {
        return {
            fetch:
                '/resource/' +
                pluralize(this.resourceName()) +
                '/' +
                this.getPrimaryKey(),
            save:
                '/resource/' +
                pluralize(this.resourceName()) +
                '/' +
                this.getPrimaryKey(),
            delete:
                '/resource/' +
                pluralize(this.resourceName()) +
                '/' +
                this.getPrimaryKey(),
        }
    }
}

export default BaseModel
